export default {
  name: 'carousel',
  type: 'layout',
  data: {
    auto: true,
    duration: 400,
    alignment: 'flex-start'
  },
  link: {
    type: 'page',
    url: {},
    pageId: '',
    target: false
  }
}
